import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi';


import { images } from '../../constants';
import './Footer.css'; 
 
const Footer = () => (
  <div className="app__footer section__padding" id="login">
  
  <div className="gpt3__footer-heading">
      <h1 className="gradient__text">With great insight and acuity, let us elevate our skills as we tell the world our stories</h1>
    </div>

    <div className="gpt3__footer-btn">
      
      <a href="https://api.whatsapp.com/send?phone=254710995224&text=Hello, more information about GLS!" rel="noreferrer" target="_blank">
      <p>Ask More Questions Here</p>        
      </a>
    </div>

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>

        <a href="https://api.whatsapp.com/send?phone=254711199202&text=Hello, more information about GLS!" rel="noreferrer" target="_blank">
        <p className="p__opensans">+254711199202</p>  
        </a>
       
        <a href="https://api.whatsapp.com/send?phone=254792548497&text=Hello, more information about GLS!" rel="noreferrer" target="_blank">
        <p className="p__opensans">+254792548497</p>  
        </a>
        

        <a href="mailto:groldotieno97@gmail.com" target="_blank" rel="noreferrer" class="contact__button">
        <p className="p__opensans">Click to e-mail</p>                   
         </a>
      </div>

      <div className="app__footer-links_logo">
        <img src={images.gericht} alt="footer_logo" />
        <p className="p__opensans">&quot;The mind is not a vessel to be filled, but a fire to be lit.&quot;</p>
        <img src={images.spoon} alt="daddy"   className="spoon__img" style={{ marginTop: 15 }} />
       
        
        <div className="app__footer-links_icons">
          <FiFacebook />
          <FiTwitter />
          <FiInstagram />
        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Working Hours</h1>
        <p className="p__opensans">Monday-Friday:</p>
        <p className="p__opensans">09:00 am - 4:00 pm</p>
        <p className="p__opensans">Saturday-Sunday:</p>
        <p className="p__opensans">10:00 pm - 10:00 pm</p>
      </div>
    </div>

    <div className="app__footer-links_work">
        
        <p className="p__opensans">Terms of use</p>
        <p className="p__opensans">Privacy policy</p>
        
      </div>

    <div className="footer__copyright">
    
      <p className="p__opensans">@2022 GLS. All rights reserved</p>
    </div>

  </div>
);

export default Footer;